import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Icon } from '~/components/ui';
import { useT } from '~/i18n';
import { isActive } from '~/lib/englishAssessment';
import { useEnglishAssessments } from '../lib/useEnglishAssessments';
import EnglishCallCard from './EnglishCallCard';

/** Cuántos días se anuncia en el panel un resultado recién salido. */
const RECENT_RESULT_DAYS = 14;

/**
 * Lo que el panel y las invitaciones muestran de la evaluación de inglés: la
 * tarjeta para llamar de cada evaluación viva y, por unos días, el aviso del
 * resultado con el enlace al informe en Perfil. Sin nada que mostrar (lo normal
 * con el flag apagado) no pinta nada, ni siquiera un hueco.
 */
export default function EnglishAssessmentsSection() {
  const t = useT('english');
  const { data, setData } = useEnglishAssessments();
  // El reloj se lee una vez al montar: render puro.
  const [mountedAt] = useState(() => Date.now());
  if (!data) return null;

  const active = data.assessments.filter((a) => isActive(a.status));
  const cutoff = mountedAt - RECENT_RESULT_DAYS * 86_400_000;
  const recent = data.assessments.filter(
    (a) => a.status === 'completed' && a.result && new Date(a.result.scored_at).getTime() >= cutoff,
  );
  if (!active.length && !recent.length) return null;
  const latestResult = recent[0]?.result ?? null;

  const onPhoneSaved = (phone: string) =>
    setData({
      ...data,
      whatsapp_phone_e164: phone,
      whatsapp_phone_confirmed: true,
      assessments: data.assessments.map((a) => (isActive(a.status) ? { ...a, phone_e164: phone } : a)),
    });

  return (
    <div className="space-y-3" data-testid="english-section">
      {active.map((assessment) => (
        <EnglishCallCard
          key={assessment._id}
          assessment={assessment}
          phone={data.whatsapp_phone_e164}
          confirmed={data.whatsapp_phone_confirmed}
          line={data.line}
          onPhoneSaved={onPhoneSaved}
        />
      ))}
      {!active.length && latestResult && (
        <Link to="/perfil/ingles" className="score-nudge rise">
          <span className="score-nudge__art">
            <Icon name="check" size={17} />
          </span>
          <span className="min-w-0">
            <span className="score-nudge__title block">
              {t.candidate.resultTitle}
              {latestResult.cefr ? `: ${latestResult.cefr}` : `: ${t.report.insufficient}`}
            </span>
            <span className="score-nudge__note block">{t.candidate.seeAll}</span>
          </span>
          <span className="score-nudge__go">
            <Icon name="arrow-right" size={18} />
          </span>
        </Link>
      )}
    </div>
  );
}
